export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-parametrizacao' */
            '@/views/exame-laboratorial/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'exame-laboratorial-parametrizacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-parametrizacao' */
                    '@/views/exame-laboratorial/parametrizacao/Form.vue'),
            },
        ]
    }
]